<section class="google-workspace-start-business">
  <div class="box">
    <div class="box-content">
      <div class="box-content__subheading"
        ><img
          src="https://flowaccountcdn.com/new_landing/image/google-workspace/start-business/google_workspace.png"
          class="box-content__subheading--layout"
          alt="google workspace"
      /></div>
      <h3 class="box-content__heading">
        <span>{{ 'GOOGLE_WORKSPACE.START_BUSINESS.HEADING' | translate }}</span>
      </h3>
      <div class="box-content__menu">
        <ng-container *ngFor="let item of mockContent; let i = index">
          <div class="box-content__menu--nav">
            <div class="nav-bar" [ngClass]="{ active: currentSlide === i + 1 }" (click)="goToSlide(i + 1)">
              <span>{{ item.navigation | translate }}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngFor="let item of mockContent; let i = index">
      <div class="box-wrapper" *ngIf="currentSlide === i + 1" [ngClass]="{ slide: currentSlide === i + 1 }">
        <div class="box-wrapper__left">
          <div class="box-wrapper__left--text">
            <div class="text-title">
              <span>{{ item.title | translate }}</span>
            </div>
            <ng-container *ngIf="item.detail">
              <ng-container *ngFor="let loop of loopArray(5); let i = index">
                <div class="text-detail">
                  <div class="text-detail__icon"><i class="fas fa-check-circle"></i></div>
                  <div class="text-detail__text">
                    <span>{{ item.detail + '.' + (i + 1) | translate }}</span></div
                  >
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.contentHtml">
              <div class="text-html">
                <span [innerHTML]="item.contentHtml | translate"></span>
              </div>
            </ng-container>
            <ng-container *ngIf="item.link">
              <div class="text-btn">
                <a
                  class="text-btn__layout"
                  [ngClass]="{ 'color-flow': i === 2 }"
                  [href]="item.link"
                  rel="noopener noreferrer"
                  target="_blank"
                  ><span>{{ 'GOOGLE_WORKSPACE.START_BUSINESS.' + (i + 1) + '.BTN' | translate }}</span></a
                >
              </div>
            </ng-container>
            <ng-container *ngIf="item.id">
              <div class="text-btn">
                <a class="text-btn__layout" (click)="scrollToTarget(item.id)"
                  ><span>{{ 'GOOGLE_WORKSPACE.START_BUSINESS.' + (i + 1) + '.BTN' | translate }}</span></a
                >
              </div>
            </ng-container>
            <ng-container *ngIf="item.textUnder">
              <div class="text-under"
                ><span>{{ item.textUnder | translate }}</span></div
              >
            </ng-container>
          </div>
        </div>
        <div class="box-wrapper__right">
          <div class="box-wrapper__right--vdo desktop">
            <video class="vdo-layout" playsinline autoplay loop muted [poster]="item.imageMock">
              <source [src]="item.vdo" type="video/mp4" loading="lazy" />
            </video>
          </div>
          <div class="box-wrapper__right--img mobile">
            <picture>
              <img [src]="item.image" [alt]="item.navigation | translate" loading="lazy" class="img-layout" />
            </picture>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
